import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { properties } from "../../utils/Properties_es";
import { CONSTANT } from "../../utils/Constants";
import { UrlBase } from "../../url/Urls";


export const getRequestInventoryControl = async (filter: string, page: number, size?: number) => {
  let responseData = {};
  await privateFetch
    .get(
      URL.REQUEST_LIST_INVENTORY_CONTROL(
        filter,
        page,
        //@ts-ignore
        size ? size : UrlBase.registration_x_page,
      )
    )
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      throw new Error("Error en consulta de permisos " + error);
    });
  return responseData;
};

export const getRequestRole = async () => {
  let responseData = {};
  await privateFetch
    .get(
      URL.REQUEST_ROLE2(null)
    )
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      //throw new Error(properties.com_parval_label_role_find_error);
      throw new Error(error);
    });
  return responseData;
};


export const findByIdRequest = async (id: any) => {
  let responseData = {};
  await privateFetch
    .get(URL.REQUEST_FIND_BY_ID(id), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_findid_error);
    });
  return responseData;
};

export const createControl = async (data: any) => {
  let responseData = {};
  const requestBody = {
   location: data.location,
   product: data.product,
   user: data.user,
   notes: data.notes || "",
  };

  await privateFetch
    .post(URL.REQUEST_CREATE_CONTROL, JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error("Error en consulta de Ubicaciones en bodega");
    });

  return responseData;
};

export const controlPreview = async (location: any, product: any) => {
  let responseData = {};
  await privateFetch
    .get(URL.REQUEST_CONTROL_PREVIEW(location,product ), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_findid_error);
    });
  return responseData;
};


export const applyControl = async (data: any) => {
  console.log(data)
  let responseData = {};
  const requestBody = {
    id: data.id,
    user: data.user
  };

  await privateFetch
    .post(URL.REQUEST_APPLY_CONTROL, JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error("Error en consulta de Ubicaciones en bodega");
    });

  return responseData;
};

export const updateQuantity = async (data: any, user:any) => {
  console.log(data)
  console.log(user)
  let responseData = {};
  const requestBody = {
    items: [
      {
        id: data.id,
        count: parseFloat(data.count)
      }
    ],
    notes: data.notes || "",
  };

  console.log(requestBody)

  await privateFetch
    .put(URL.REQUEST_UPDATE_CONTROL(user), JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error("Error en actualización de cantidad del producto");
    });

  return responseData;
};


export const findByIdRequestById = async (id: any) => {
  let responseData = {};
  await privateFetch
    .get(URL.REQUEST_ROLE_BY_ID(id), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_findid_error);
    });
  return responseData;
};

export const createRequest = async (data: any) => {
  console.log(data)
  let responseData = {};

  const requestBody = {
    roleName: data.roleName,
    description: data.description,
    user: data.userCreated,
  };
  await privateFetch

    .post(URL.REQUEST_ROLE_CREATE, JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })

    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_save_error);
    });
  return responseData;
};

export const updateRequest = async (data: any) => {
  let responseData = {};
  const requestBody = {
    id: data.id,
    roleName: data.roleName,
    description: data.description,
    user: data.user,

  };
  await privateFetch

    .put(URL.REQUEST_ROLE_UPDATE(data.id), JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_update_error);
    });
  return responseData;
};


export const deleteInventoryControl = async (id: number) => {
  let responseData = {};
  await privateFetch
    .delete(URL.REQUEST_DELETE_INVENTORY_CONTROL(id))
    .then(async (response) => {
      responseData = response.data;
    })
    .catch((error: any) => {
      throw new Error(
        error.response?.data?.message ??
          properties.com_parval_label_inventory_control_delete_error
      );
    });
  return responseData;
};
